import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Trans, useTranslation } from 'react-i18next';
import { Grid, Typography, Button, useMediaQuery } from '@material-ui/core';

// CONSTANTS
import { ROUTE_FREE_TV } from '@/constants/routes';

// UTILITY
import { getS3ImageUrl } from '@/utility/content';

// COMPONENTS
import Link from '@/components/Link';

// STYLES
import { Container } from './styles';

const FreeTvImg = getS3ImageUrl('/free-tv/free-tv-section.png');
const FreeTvImg2x = getS3ImageUrl('/free-tv/free-tv-section-2x.png');

const FreeTVSection = ({ titleProps, subtitleProps }) => {
  const [t] = useTranslation();
  const downXs = useMediaQuery(({ breakpoints }) => breakpoints.down('xs'));

  const benefits = [
    t('freeTvSection.benefits.item1'),
    t('freeTvSection.benefits.item2'),
    t('freeTvSection.benefits.item3'),
  ];

  const btnContent = (
    <div className="text-center">
      <Button
        to={ROUTE_FREE_TV}
        className="m-b-40"
        size={clsx(downXs ? 'medium' : 'large')}
        color="primary"
        component={Link}
        fullWidth={downXs}
      >
        {t('freeTvSection.btn')}
      </Button>
    </div>
  );

  const titleContent = (
    <>
      <Typography
        {...titleProps}
        className={clsx('m-b-15 text-bold', !!titleProps.className && titleProps.className)}
        component="h2"
        variant={downXs ? 'h4' : 'h2'}
        align="center"
      >
        {t('freeTvSection.title')}
      </Typography>
      <Typography
        {...subtitleProps}
        className={clsx('m-b-30', !!titleProps.className && subtitleProps.className)}
        variant="subtitle2"
        align="center"
      >
        <Trans>{t('freeTvSection.subtitle')}</Trans>
      </Typography>
    </>
  );

  return (
    <Container className={clsx('section free-tv-section')}>
      <div className="page-content">
        {titleContent}
        {btnContent}
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6}>
            <div className="free-tv-section__img">
              <img srcSet={`${FreeTvImg2x} 2x`} src={FreeTvImg} alt="free-tv" />
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            {!!benefits?.length && (
              <ul className="pros-cons-list pros-cons-list--square-icons">
                {benefits.map((item, idx) => (
                  <li className="pcl-item" key={idx}>
                    <i className="icon-check" />
                    {item}
                  </li>
                ))}
              </ul>
            )}
          </Grid>
        </Grid>
      </div>
    </Container>
  );
};

FreeTVSection.defaultProps = {
  titleProps: {},
  subtitleProps: {},
};

FreeTVSection.propTypes = {
  titleProps: PropTypes.object,
  subtitleProps: PropTypes.object,
};

export default React.memo(FreeTVSection);
